var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02083 10.0833V1.60413C8.02083 1.42179 7.9484 1.24692 7.81947 1.11799C7.69054 0.989059 7.51567 0.916626 7.33333 0.916626H1.83333C1.651 0.916626 1.47613 0.989059 1.3472 1.11799C1.21827 1.24692 1.14583 1.42179 1.14583 1.60413V9.39579C1.14583 9.57813 1.21827 9.753 1.3472 9.88193C1.47613 10.0109 1.651 10.0833 1.83333 10.0833H8.02083ZM8.02083 10.0833H9.16667C9.349 10.0833 9.52387 10.0109 9.6528 9.88193C9.78173 9.753 9.85417 9.57813 9.85417 9.39579V5.49996C9.85417 5.3784 9.80588 5.26182 9.71993 5.17587C9.63397 5.08991 9.51739 5.04163 9.39583 5.04163H8.47917C8.35761 5.04163 8.24103 5.08991 8.15508 5.17587C8.06912 5.26182 8.02083 5.3784 8.02083 5.49996V10.0833Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 0.916667,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52083 2.75H4.35417M2.52083 4.35417H5.27083",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.c871ae0a0dab059e5d17be31d1711f34.svg";
export { ForwardRef as ReactComponent };